"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFirstContentfulPaint;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _performance = require("./performance");

var _getFirstHiddenTime = _interopRequireDefault(require("./getFirstHiddenTime"));

function getFirstContentfulPaint() {
  var _getEntriesByName = (0, _performance.getEntriesByName)(_performance.EntryName.FIRST_CONTENTFUL_PAINT),
      _getEntriesByName2 = (0, _slicedToArray2.default)(_getEntriesByName, 1),
      performanceEntry = _getEntriesByName2[0];

  if (performanceEntry != null && performanceEntry.startTime < (0, _getFirstHiddenTime.default)()) {
    return performanceEntry.startTime;
  }

  return undefined;
}